import { useQuery } from '@tanstack/react-query';
import { SeloStatus } from '../../components/ui';
import { obterSaude } from '../../lib/api';

/** Mostra se a API e o banco estão no ar. Atualiza a cada 30 s. */
export function IndicadorSaude() {
  const { data, isPending, isError } = useQuery({
    queryKey: ['saude'],
    queryFn: obterSaude,
    refetchInterval: 30_000,
    retry: 1,
  });

  let conteudo;
  if (isPending) conteudo = <SeloStatus tipo="neutro">Verificando sistema…</SeloStatus>;
  else if (isError) conteudo = <SeloStatus tipo="perigo">Servidor fora do ar</SeloStatus>;
  else if (data.banco !== 'ok')
    conteudo = <SeloStatus tipo="alerta">Banco de dados indisponível</SeloStatus>;
  else conteudo = <SeloStatus tipo="sucesso">Sistema no ar</SeloStatus>;

  return (
    <div role="status" aria-live="polite" aria-label="Situação do sistema">
      {conteudo}
    </div>
  );
}
